(function () {
  'use strict';

  var library = document.querySelector('[data-resource-library]');
  if (!library) return;

  /* ── DOM references ──────────────────────────────────────── */
  var input = library.querySelector('[data-resource-search]');
  var searchBtn = library.querySelector('[data-resource-search-btn]');
  var grid = library.querySelector('[data-results-grid]');
  var titleEl = library.querySelector('[data-results-title]');
  var countEl = library.querySelector('[data-results-count]');
  var emptyEl = library.querySelector('[data-results-empty]');
  var paginationEl = library.querySelector('[data-resource-pagination]');

  /* ── Configuration from data attributes ──────────────────── */
  var perPage = parseInt(library.dataset.perPage, 10) || 24;
  var serverPages = parseInt(library.dataset.paginatePages, 10) || 1;
  var chevronLeft = library.dataset.iconPrev || '';
  var chevronRight = library.dataset.iconNext || '';

  /* ── State ───────────────────────────────────────────────── */
  var items = Array.from(library.querySelectorAll('[data-resource-item]'));
  var currentPage = 1;
  var allItemsLoaded = serverPages <= 1;
  var debounceTimer = null;
  var abortController = null;

  /* ── Utilities ───────────────────────────────────────────── */
  function escapeHtml(str) {
    var el = document.createElement('span');
    el.textContent = str;
    return el.innerHTML;
  }

  function getVisibleItems() {
    return items.filter(function (item) {
      return item.dataset.filtered !== 'true';
    });
  }

  /* ── Fetch remaining server pages ────────────────────────── */
  function fetchRemainingPages() {
    if (serverPages <= 1) return;

    var basePath = window.location.pathname;
    var fetches = [];

    for (var p = 2; p <= serverPages; p++) {
      fetches.push(
        fetch(basePath + '?page=' + p).then(function (r) { return r.text(); })
      );
    }

    Promise.all(fetches).then(function (pages) {
      var parser = new DOMParser();

      pages.forEach(function (html) {
        var doc = parser.parseFromString(html, 'text/html');
        var newItems = doc.querySelectorAll('[data-resource-item]');

        newItems.forEach(function (node) {
          var imported = document.importNode(node, true);
          imported.style.display = 'none';
          imported.dataset.filtered = 'false';
          grid.appendChild(imported);
          items.push(imported);
        });
      });

      allItemsLoaded = true;

      if (input && input.value.trim()) {
        performSearch(input.value);
      } else {
        showPage(currentPage);
      }
    });
  }

  /* ── Pagination ──────────────────────────────────────────── */
  function showPage(page) {
    currentPage = page;
    var visible = getVisibleItems();
    var start = (page - 1) * perPage;
    var end = start + perPage;

    items.forEach(function (item) { item.style.display = 'none'; });
    visible.forEach(function (item, idx) {
      item.style.display = (idx >= start && idx < end) ? '' : 'none';
    });

    renderPagination(visible.length);
  }

  function buildPageRange(totalPages) {
    var pages = [1];
    var rangeStart = Math.max(2, currentPage - 2);
    var rangeEnd = Math.min(totalPages - 1, currentPage + 2);

    if (rangeStart > 2) pages.push('...');
    for (var i = rangeStart; i <= rangeEnd; i++) pages.push(i);
    if (rangeEnd < totalPages - 1) pages.push('...');
    if (totalPages > 1) pages.push(totalPages);

    return pages;
  }

  function renderPagination(totalItems) {
    if (!paginationEl) return;

    var totalPages = Math.ceil(totalItems / perPage);
    if (totalPages <= 1) {
      paginationEl.innerHTML = '';
      return;
    }

    var html = '';

    if (currentPage > 1) {
      html += '<a href="#" class="resource-library__page-arrow" data-page="' + (currentPage - 1) + '" aria-label="Previous page">' + chevronLeft + '</a>';
    }

    buildPageRange(totalPages).forEach(function (p) {
      if (p === '...') {
        html += '<span class="resource-library__page-link">\u2026</span>';
      } else if (p === currentPage) {
        html += '<span class="resource-library__page-link resource-library__page-link--active" aria-current="page">' + p + '</span>';
      } else {
        html += '<a href="#" class="resource-library__page-link" data-page="' + p + '">' + p + '</a>';
      }
    });

    if (currentPage < totalPages) {
      html += '<a href="#" class="resource-library__page-arrow" data-page="' + (currentPage + 1) + '" aria-label="Next page">' + chevronRight + '</a>';
    }

    paginationEl.innerHTML = html;

    paginationEl.querySelectorAll('[data-page]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        showPage(parseInt(link.dataset.page, 10));
        window.scrollTo({ top: grid.offsetTop - 100, behavior: 'smooth' });
      });
    });
  }

  /* ── Search ──────────────────────────────────────────────── */
  function filterItems(query) {
    var visible = 0;

    items.forEach(function (item) {
      var haystack = (
        item.dataset.title + ' ' +
        item.dataset.sku + ' ' +
        item.dataset.handle
      ).toLowerCase();
      var match = query === '' || haystack.includes(query);

      item.dataset.filtered = match ? 'false' : 'true';
      if (match) visible += 1;
    });

    return visible;
  }

  function removeApiResults() {
    if (!grid) return;
    grid.querySelectorAll('[data-api-result]').forEach(function (el) {
      el.remove();
    });
  }

  function updateUI(rawQuery, visible) {
    var query = rawQuery.trim();

    if (titleEl) {
      titleEl.textContent = query
        ? 'Search Results for \u201c' + query + '\u201d'
        : 'Resource Library';
    }

    if (countEl) {
      countEl.textContent = query
        ? visible + ' product' + (visible !== 1 ? 's' : '') + ' found'
        : '';
    }

    if (emptyEl) {
      emptyEl.hidden = visible !== 0;
    }

    if (paginationEl && query) {
      paginationEl.innerHTML = '';
    }
  }

  function buildApiCard(product) {
    var sku = '';
    if (product.variants && product.variants.length) {
      sku = product.variants[0].sku || '';
    }

    var card = document.createElement('article');
    card.className = 'resource-card';
    card.setAttribute('data-api-result', '');

    var mediaHtml = product.image
      ? '<img src="' + escapeHtml(product.image) + '" loading="lazy" width="400" height="400" alt="">'
      : '<span class="resource-card__empty">No image</span>';

    card.innerHTML =
      '<div class="resource-card__media">' + mediaHtml + '</div>' +
      '<div class="resource-card__body">' +
        '<div class="resource-card__info">' +
          (product.vendor ? '<span class="resource-card__vendor">' + escapeHtml(product.vendor) + '</span>' : '') +
          '<h3 class="resource-card__title">' + escapeHtml(product.title) + '</h3>' +
          (sku ? '<span class="resource-card__sku">' + escapeHtml(sku) + '</span>' : '') +
        '</div>' +
        '<div class="resource-card__actions">' +
          '<a class="resource-card__link" href="' + escapeHtml(product.url) + '">View Resources</a>' +
        '</div>' +
      '</div>';

    return card;
  }

  function performSearch(rawValue) {
    var query = rawValue.trim().toLowerCase();
    removeApiResults();

    /* Empty query — reset to paginated view */
    if (!query) {
      filterItems('');
      updateUI('', getVisibleItems().length);
      currentPage = 1;
      showPage(1);
      return;
    }

    var visible = filterItems(query);

    /* Show matching, hide non-matching (no pagination during search) */
    items.forEach(function (item) {
      item.style.display = item.dataset.filtered === 'false' ? '' : 'none';
    });

    /* Collect already-visible handles to skip API duplicates */
    var visibleHandles = {};
    items.forEach(function (item) {
      if (item.dataset.filtered === 'false') {
        visibleHandles[item.dataset.handle] = true;
      }
    });

    /* Abort any in-flight request */
    if (abortController) abortController.abort();
    abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;

    var url =
      '/search/suggest.json?q=' + encodeURIComponent(rawValue.trim()) +
      '&resources[type]=product&resources[limit]=10' +
      '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor';

    fetch(url, abortController ? { signal: abortController.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products =
          (data.resources && data.resources.results && data.resources.results.products) || [];

        products.forEach(function (product) {
          var handle = product.url.replace('/products/', '').split('?')[0];
          if (visibleHandles[handle]) return;
          visibleHandles[handle] = true;
          grid.appendChild(buildApiCard(product));
          visible += 1;
        });

        updateUI(rawValue, visible);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        updateUI(rawValue, visible);
      });
  }

  /* ── Event listeners ─────────────────────────────────────── */
  if (input) {
    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        performSearch(input.value);
      }, 300);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        clearTimeout(debounceTimer);
        performSearch(input.value);
      }
    });
  }

  if (searchBtn) {
    searchBtn.addEventListener('click', function () {
      clearTimeout(debounceTimer);
      performSearch(input ? input.value : '');
    });
  }

  /* ── Initialize ──────────────────────────────────────────── */
  items.forEach(function (item) { item.dataset.filtered = 'false'; });
  showPage(1);
  fetchRemainingPages();
})();
